export const MAX_NUMBER_OF_LINKS_PER_PAGE = 5

export const COMMENT_NUMBER_PER_PAGE = 20
